import { LocalesEnum } from 'src/generated/operations';
import { factoryIntlNumberFormat } from 'src/utils/factoryIntlNumberFormat.ts';

export const numericToLocalized = (numeric: string, decimalDigits: number, currentLocale: LocalesEnum) => {
    if (numeric === '') {
        return numeric;
    }

    const [_, decimalPart = ''] = numeric.split('.');

    return factoryIntlNumberFormat(
        currentLocale,
        {
            minimumFractionDigits: decimalDigits < decimalPart.length ? decimalDigits : decimalPart.length,
            maximumFractionDigits: decimalDigits,
        },
    ).format(Number(numeric));
};
